import { IF, ModalForm } from 'lidya-common-components';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import PropTypes from 'prop-types';
import { GatsbyImage } from 'gatsby-plugin-image';
import { useModalData } from '../../common/providers/modalProvider/modalDataProvider.useModalData';
import { COUNTRY_LANGUAGE_LIST } from '../../common/webSiteLanguages';
import { findImage } from '../../common/imageLoader';
import { useGlobalData } from '../../../providers/globalDataProvider/globalDataProvider.useGlobalData';
import { POSSIBLE_FORMS } from './sign.up.memo.form';
import SignUpForm from './sign.up.form';

const getImage = ({ imageName, country }) => {
  let leftImage = findImage(imageName);
  if (leftImage.src === '') {
    leftImage = findImage(`signup_${country}`);
  }
  if (leftImage.src === '') {
    leftImage = findImage('signup');
  }
  return leftImage;
};

const ImageComponent = function ({ image }) {
  const { country } = useGlobalData();
  const { t } = useTranslation();
  const imageToUse = getImage({ imageName: image, country });
  return (
    <GatsbyImage
      image={imageToUse}
      alt={t(`images.sign.up.${country}.alt`)}
      title={t('images.sign.up.title')}
    />
  );
};
ImageComponent.propTypes = {
  image: PropTypes.string.isRequired,
};

export const SignUpModalComponent = function ({ signupType, isCreateAccount }) {
  const { t } = useTranslation();
  const { showModal, toggleModal } = useModalData();
  const { country } = useGlobalData();
  const [image, setImage] = useState(`signup_${country}`);
  const { hasWebApp } = COUNTRY_LANGUAGE_LIST[country];
  const nSignupType = signupType === POSSIBLE_FORMS.SIGN_UP && !hasWebApp
    ? POSSIBLE_FORMS.NEWSLETTER
    : signupType;
  const SignUpFormComp = useCallback(() => (
    <SignUpForm
      setImage={setImage}
      signupType={nSignupType}
      isOpen={showModal}
      isCreateAccount={isCreateAccount}
    />
  ), [isCreateAccount, nSignupType, showModal]);

  const ImageComp = useCallback(() => (
    <ImageComponent image={image} />
  ), [image]);

  return (
    <IF condition={showModal}>
      <ModalForm
        id={`SignupModalForm${nSignupType}`}
        show={showModal}
        onClose={toggleModal}
        overImageText={
          nSignupType !== POSSIBLE_FORMS.INVESTORS
            ? t('web.popup.sign.up.msg')
            : `${t('web.investors.invest.be.investor')}. ${t(
              'web.investors.invest.be.improve',
            )}`
        }
        FormComponent={SignUpFormComp}
        ImageComponent={ImageComp}
      />
    </IF>
  );
};

SignUpModalComponent.propTypes = {
  // forceShow: PropTypes.bool,
  isCreateAccount: PropTypes.bool,
  signupType: PropTypes.oneOf([
    POSSIBLE_FORMS.SIGN_UP,
    POSSIBLE_FORMS.INVESTORS,
    POSSIBLE_FORMS.NEWSLETTER,
  ]),
};

SignUpModalComponent.defaultProps = {
  signupType: POSSIBLE_FORMS.NEWSLETTER,
  // forceShow: false,
  isCreateAccount: false,
};

export default SignUpModalComponent;
